import React from 'react';
import { FormattedMessage } from 'react-intl';
import { takeEvery, put, call } from 'redux-saga/effects';
import { setSubscriptionAccountList } from 'domains/subscription/actions';
import { pushToast } from 'containers/ToastManager/actions';
import catchErrors from 'utils/commands/catchErrors';

import messages from '../messages';
import * as constants from '../constants';

export function* sendRequest(connection) {
  const iamSubscriptionUserList = yield call(connection.fetch.bind(connection), constants.RTM_IAM_SUBSCRIPTION_USER_LIST);
  if (iamSubscriptionUserList.type === constants.RTM_IAM_SUBSCRIPTION_USER_LIST_OK) {
    const accounts = iamSubscriptionUserList.response.accounts;
    yield put(setSubscriptionAccountList(accounts));
  } else {
    yield put(pushToast({
      type: 'simple',
      message: <FormattedMessage {...messages.failedSubscriptionAccountListFetch} />,
    }));
  }
}

export default function* (connection) {
  yield takeEvery(constants.COMMAND_IAM_SUBSCRIPTION_USER_LIST, catchErrors, sendRequest, connection);
}
